module.exports = __webpack_public_path__ + "assets/logo.21593322.svg";